import React from 'react';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import { inRoomDiningDiscountsSelector } from '../../../servicesSlice';
import { useSelector } from 'react-redux';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

const ItemCreateDiscount = (props) => {
  const { formData, setFormData, onChangeRadioButton } = props;
  const originalDiscounts = useSelector(inRoomDiningDiscountsSelector);

  const onChangeDiscountStatus = (e, fieldName) => {
    formData.discount.validations = e.target.value === 'active' ? ['required'] : [];
    onChangeRadioButton(e, fieldName);
  };

  return (
    <div className='row px-3 w-100 d-flex mt-4'>
      <div className='row'>
        <h4 className='tab-title'>Discounts</h4>
        <div className='col-md-12 mb-3'>
          <RadioGroup
            row
            aria-label={formData.discountStatus.fieldName}
            onChange={(e) => {
              onChangeDiscountStatus(e, 'discountStatus');
            }}
            value={formData.discountStatus.value}
            name={formData.discountStatus.fieldName}
            className='document-type mb-3'
          >
            <FormControlLabel
              value='active'
              control={<Radio color='primary' />}
              label='Active'
              className='col-md-4'
            />
            <FormControlLabel
              value='inactive'
              control={<Radio color='primary' />}
              label='Inactive'
              className='col-md-4'
            />
          </RadioGroup>
        </div>
      </div>
      {formData?.discountStatus?.value === 'active' && (
        <div className='col-md-12 row'>
          <div className='col-md-6'>
            <CustomSelect
              item={formData?.discount}
              handleInputChange={(e) => {
                setFormData({ discount: e });
              }}
              options={originalDiscounts?.filter((discount) => discount?.status === true)}
              hideNullOption
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemCreateDiscount;
